export function KroktimeIcon({ size = 48, color = 'currentColor' }) {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="200 125 600 600"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)"
        fill={color}
        stroke="none"
      >
        <path
          d="M5002 8145 c-133 -41 -200 -195 -141 -325 43 -96 101 -130 219 -130
l80 0 0 -145 0 -145 -474 0 c-507 0 -567 -5 -678 -51 -196 -83 -355 -262 -407
-459 -19 -70 -29 -133 -30 -187 l-1 -23 -379 0 c-377 0 -378 0 -412 -23 -123
-83 -102 -305 34 -356 18 -7 159 -11 393 -11 l364 0 0 -199 c0 -110 3 -206 6
-215 6 -15 -56 -16 -650 -16 -719 0 -688 2 -742 -58 -75 -86 -49 -253 49 -312
31 -19 54 -20 684 -20 l652 0 3 -205 3 -205 -385 0 c-434 0 -439 -1 -496 -75
-24 -32 -29 -49 -32 -110 -5 -86 17 -138 75 -182 l36 -28 398 -3 397 -3 5
-272 c4 -300 10 -334 71 -462 67 -139 192 -262 340 -334 167 -82 50 -76 1516
-76 1443 0 1325 -5 1485 62 188 79 329 245 406 478 22 67 23 85 27 445 l4 374
81 90 c45 50 88 98 96 106 33 35 161 244 161 264 0 2 -30 18 -66 35 -90 42
-136 81 -182 154 -49 78 -71 136 -91 239 l-16 82 -46 12 c-122 31 -236 132
-282 251 -36 94 -41 154 -23 243 13 58 13 76 3 81 -159 93 -248 176 -306 288
-46 91 -61 154 -61 264 0 118 37 236 94 304 l27 32 -23 16 c-13 8 -58 27 -101
40 l-78 25 -440 0 -439 0 0 145 0 145 70 0 c39 0 72 0 75 0 17 -2 106 56 123
79 74 100 61 260 -28 334 -63 53 -98 57 -529 56 -301 0 -406 -4 -439 -14z
m658 -1350 c389 -72 687 -253 910 -551 63 -84 166 -280 199 -379 69 -207 89
-447 56 -658 -96 -612 -578 -1079 -1204 -1168 -103 -14 -323 -7 -436 15 -447
87 -818 386 -1008 811 -141 316 -153 686 -34 1030 140 402 495 737 913 860
137 40 243 53 409 50 88 -2 176 -7 195 -10z"
        />
        <path
          d="M5280 6499 c-143 -21 -317 -90 -446 -175 -149 -99 -310 -292 -382
-459 -123 -284 -118 -625 13 -902 158 -335 437 -550 805 -619 127 -24 333 -15
465 20 309 83 566 297 705 588 110 229 131 551 53 793 -131 403 -464 688 -878
750 -107 16 -245 18 -335 4z m766 -575 c19 -9 44 -30 56 -47 28 -39 36 -123
15 -163 -9 -16 -159 -171 -334 -346 -276 -274 -324 -318 -360 -327 -72 -20
-113 -1 -212 92 -248 234 -322 309 -332 334 -29 78 5 169 76 203 85 41 122 27
250 -98 55 -54 117 -113 138 -132 l37 -34 258 256 c141 140 266 261 277 267
29 16 92 13 131 -5z"
        />
      </g>
    </svg>
  );
}
